<page-content [fullPageWidth]="false">
  <header-elitment header [hasSideMenu]="true"></header-elitment>
  <side-menu left-menu>
    <athlete-side-menu></athlete-side-menu>
  </side-menu>

  <error-401 *ngIf="is401"></error-401>
  <error-404 *ngIf="is404"></error-404>

  <module-content *ngIf="!isLoading && !is401 && !is404" title="{{ 'Communications' | translate }}">
    <div class="box-input">
      <mat-form-field color="primary">
                <textarea matInput
                          mat-autosize
                          #messageInput
                          [formControl]="observationForm"
                          type="text"
                          maxlength="{{ OBSERVATION_MAX_LENGTH }}"
                          [placeholder]="'Write_Communication' | translate"
                          (change)="changeObservation(messageInput.value)"
                          rows="2">
                </textarea>
      </mat-form-field>

      <button
        mat-icon-button
        align="end"
        color="accent"
        matTooltip="{{ 'Send' | translate }}"
        [disabled]="observationForm.value?.length == 0"
        (click)="onNewObservationClicked()">
        <i class="material-icons">
          send
        </i>
      </button>
    </div>

    <ng-container *ngFor="let observation of (observations)" class="line">
      <div class="msg">
        <div class="bubble observation-box" [class.comment]="false">
          <div class="txt">
            <span class="name">{{ observation.author.firstName }} {{ observation.author.lastName }}</span>
            <span class="timestamp">{{ observation.created_at | appDate:'dd MMM yyyy':'':currentLang }}</span>
            <div class="message" [innerHTML]="observation.message | emojify"></div>
          </div>
          <div class="bubble-arrow"></div>
        </div>
        <button mat-icon-button [matMenuTriggerFor]="observationMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #observationMenu="matMenu" xPosition="after">
          <button
            mat-menu-item
            (click)="onNewCommentClicked(observation)">
            <mat-icon>edit</mat-icon>
            <span>{{ 'CommentNew' | translate }}</span>
          </button>
          <button
            mat-menu-item
            [disabled]="!observation.rights.edit"
            (click)="onEditObservationClicked(observation)">
            <mat-icon>edit</mat-icon>
            <span>{{ 'Edit' | translate }}</span>
          </button>
          <button
            mat-menu-item
            [disabled]="!observation.rights.delete"
            (click)="onDeleteObservationClicked(observation)">
            <mat-icon>delete</mat-icon>
            <span>{{ 'Delete' | translate }}</span>
          </button>
        </mat-menu>
      </div>
      <ng-container *ngFor="let comment of observation.comments" class="line">
        <div class="msg">
          <div class="bubble observation-box" [class.comment]="true">
            <div class="txt">
              <span class="name">{{ comment.author.firstName }} {{ comment.author.lastName }}</span>
              <span class="timestamp">{{ comment.created_at | appDate:'dd MMM yyyy':'':currentLang }}</span>
              <div class="message" [innerHTML]="comment.message | emojify"></div>
            </div>
            <div class="bubble-arrow"></div>
          </div>
          <button mat-icon-button [matMenuTriggerFor]="commentMenu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #commentMenu="matMenu" xPosition="after">
            <button
              mat-menu-item
              [disabled]="!comment.rights.edit"
              (click)="onEditCommentClicked(observation, comment)">
              <mat-icon>edit</mat-icon>
              <span>{{ 'Edit' | translate }}</span>
            </button>
            <button
              mat-menu-item
              [disabled]="!comment.rights.delete"
              (click)="onDeleteCommentClicked(observation, comment)">
              <mat-icon>delete</mat-icon>
              <span>{{ 'Delete' | translate }}</span>
            </button>
          </mat-menu>
        </div>
      </ng-container>
    </ng-container>
  </module-content>
</page-content>
